import React, {useContext, useEffect, useState} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import {Route, Redirect} from 'react-router-dom';
import getIsAuthorized from './isAuthorized';

function AuthRouter({children, requiredRole, ...rest}) {
	//This router requires the user to be loggedin and bought the content
	let user = useContext(GlobalContext).user;
	let isLoading = useContext(GlobalContext).userLoading;
	let userRole = user ? user.role : null;
	let isAuthorized = getIsAuthorized(userRole, requiredRole);

	return (
		<Route
			{...rest}
			render={() => {
				if (isLoading) {
					return <div>Loading</div>;
				} else if (!user) {
					window.location.href = '/signup';
				} else if (!isAuthorized) {
					window.location.href = '/home';
				} else {
					return children;
				}
			}}
		/>
	);

	function safylyUpdateState(seter, value, hasExited) {
		if (!hasExited) {
			seter(value);
		}
	}
}

export default AuthRouter;
